import { IFilter } from '../../types/filters';
import { CeilingHeightContainer } from '../../containers/advancedFilters/CeilingHeightContainer';

export const ceilingHeight: IFilter = {
  component: CeilingHeightContainer,
};
